import { Base } from './base-model';
import { Type } from 'class-transformer';

export class Page extends Base {
    slug: string
    summary: string
    content: string
    title: string
    parentId: number
    type: string
    color: string
    width: string
    order: number
    navVisible: boolean
    @Type(() => Page)
    pages: Page[]

    static defaults(): Page {
        const page = new Page()
        page.title = ''
        page.slug = ''
        page.content = ''
        page.parentId = 0
        page.type = 'page'
        page.color = ''
        page.width = 'normal'
        page.order = 0
        page.navVisible = true
        page.pages = []
        return page
    }
}
